<div
  class="asset-container-parent"
  id="asset-{{ asset().id }}"
  [attr.data-transition-to-page]="pageTransitions()"
  [class.selected]="selected()"
  [class.with-hover]="gallery()?.enabled_feedback_options?.includes('status')"
  [class.not-dragging]="!draggingAny()"
  [class.dark]="dark()"
>
  @if (inView()) {
    <div
      class="asset-container"
      [class.dragging-item]="dragging()"
      appInferredHover="asset-{{ asset().id }}"
      (onInferredHoverChange)="inferredHovering.set($event)"
      (mouseenter)="hovering.set(true)"
      (mouseleave)="hovering.set(false)"
      (mousemove)="assetMouseMove($event)"
    >
      <div class="asset-item-container" (click)="assetClick.emit($event)">
        <div class="asset" (contextmenu)="assetRightClick.emit($event)">
          @if (asset() | canDisplayAsset) {
            @let dimensions = asset().version_data | assetVersionDimensions;
            @let imgSrc =
              asset().version_data
                | assetVersionUrl
                  : asset().version_data.uuid
                  : asset().version_data.status
                  : asset().version_data.watermark_uuid
                  : (dimensions.width > dimensions.height ? cellSize() * 1.5 : cellSize())
                  : true
                  : asset().watermark_enabled;
            @if (asset().type === 'image' || asset().type === 'document') {
              <img [src]="imgSrc" [alt]="asset().version_data.asset_name" id="{{ asset().id }}" />
            } @else {
              <img
                [src]="imgSrc"
                [alt]="asset().version_data.asset_name"
                [class.hidden-asset]="isDesktop() && hovering()"
                id="{{ asset().id }}"
              />
              <div class="video-indicator">
                <app-svg src="/assets/icons/play.svg"></app-svg>
              </div>
              @if (hovering() && isDesktop()) {
                <div class="video-hover-line" [style.left]="hoverAssetOffsetX() * 100 + '%'"></div>
                <app-video-thumbnail
                  [currentTime]="hoverAssetOffsetX() * asset().version_data.data['duration']"
                  [assetVersion]="asset().version_data"
                  #thumbnail
                ></app-video-thumbnail>
                @if (thumbnail.loading) {
                  <div class="video-indicator loading">
                    <app-svg src="/assets/icons/play.svg"></app-svg>
                  </div>
                }
              }
            }
          } @else if (asset().version_data.status === 'failed') {
            @let assetSrc = asset().version_data | failedAssetVersionUrl: cellSize() | async;
            <img [src]="assetSrc" [alt]="asset().version_data.asset_name" id="{{ asset().id }}" />
          }
        </div>
      </div>
      <div class="asset-feedback-and-activity-counts">
        <a [routerLink]="[asset().id]" fragment="comments">
          <app-activity-badge
            [asset]="asset()"
            [onlyDot]="!hovering() && inferredHovering()"
            [hideWhenEmpty]="true"
            [hasLink]="true"
            color="grey-80"
          >
          </app-activity-badge>
        </a>
      </div>
      <ng-container *onlyForScreens="['desktop', 'tablet']">
        <!-- Asset bottom actions -->
        @if ((hovering() || inferredHovering()) && galleryPermissions()) {
          <div class="asset-actions-top" [@assetActionsTop]>
            <div class="spacer"></div>
            @if (galleryPermissions().can_edit) {
              <app-context-menu
                [options]="{ noSpacing: true, width: '240px' }"
                #assetBottomMenu
                contextHoverIdentifier="asset-{{ asset().id }}"
              >
                <button
                  appButton
                  name="asset-options"
                  location="advanced-mode"
                  color="hard-simple"
                  [iconButton]="true"
                  height="-1"
                  shape="round"
                  contextButton
                  #button
                >
                  <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
                </button>
                <div contextContent>
                  @if (assetBottomMenu.isOpen()) {
                    <app-asset-context-menu
                      [asset]="asset()"
                      [gallery]="gallery()"
                      [galleryPermissions]="galleryPermissions()"
                      [clientEl]="button"
                      (onClose)="assetBottomMenu.close()"
                      (onNewVersion)="onNewVersion.emit()"
                      (openShare)="openShareDialog()"
                    >
                    </app-asset-context-menu>
                  }
                </div>
              </app-context-menu>
            } @else if (asset() | canDownloadAsset: gallery() : galleryPermissions()) {
              <app-asset-download-button
                location="advanced-mode"
                [asset]="asset()"
                [gallery]="gallery()"
                [galleryPermissions]="galleryPermissions()"
              >
                <button
                  appButton
                  name="download"
                  location="advanced-mode"
                  color="hard-simple"
                  [iconButton]="true"
                  height="-1"
                  shape="round"
                >
                  <app-svg src="/assets/icons/download.svg" color="grey-30"></app-svg>
                </button>
              </app-asset-download-button>
            }
          </div>
        }
      </ng-container>
      <!-- Favorite button with likes -->
      @if (asset().likes && allowedAndEnabledFeedbackOptions()) {
        <div class="favorited-button-container" [class.liked]="asset().is_liked">
          <app-favorite-button [asset]="asset()" [disabled]="!galleryPermissions().can_edit || clientMode()">
            <button
              contextButton
              appButton
              name="toggle-like"
              location="advanced-mode"
              [appTooltip]="!galleryPermissions().can_edit || clientMode() ? 'Favorite' : undefined"
              color="simple"
              shape="round"
              [iconButton]="true"
              [height]="isMobile() ? '-2' : '-1'"
              (click)="toggleAssetLike.emit()"
            >
              <app-svg src="/assets/icons/heart-filled.svg" [attr.color]="asset().is_liked ? 'warn' : 'gray'">
              </app-svg>
            </button>
          </app-favorite-button>
          <span>
            <app-smooth-counter [value]="asset().likes"> </app-smooth-counter>
          </span>
        </div>
      }
      @if (asset().color_label && allowedAndEnabledFeedbackOptions()) {
        <div class="color-label-button-container">
          @if (allowedAndEnabledFeedbackOptions().includes('color_label')) {
            <app-context-menu
              [options]="{ noSpacing: true, width: '240px' }"
              #menu
              contextHoverIdentifier="asset-{{ asset().id }}"
              appTooltip="Add a Color Label"
            >
              <button
                appButton
                name="asset-color-label-dropdown"
                location="advanced-mode"
                [color]="(asset().color_label | colorLabelColor) || 'hard-simple'"
                [iconButton]="true"
                height="-1"
                shape="round"
                contextButton
              >
                <app-svg src="/assets/icons/color-label-filled.svg"></app-svg>
              </button>
              <div contextContent>
                <div class="button-menu">
                  <app-color-label-context
                    [currentColorLabel]="asset().color_label"
                    location="advanced-mode"
                    [colorLabels]="colorLabels()"
                    (updateColorLabel)="updateAssetColorLabel.emit($event); menu.close()"
                  ></app-color-label-context>
                </div>
              </div>
            </app-context-menu>
          }
        </div>
      }
      <ng-container *onlyForScreens="['desktop', 'tablet']">
        <!-- Asset bottom actions -->
        @if ((hovering() || inferredHovering()) && galleryPermissions()) {
          <div class="asset-actions-bottom" [@assetActionsBottom]>
            <!-- Favorite button without likes-->
            @if (allowedAndEnabledFeedbackOptions().includes('favourite')) {
              <button
                appButton
                name="toggle-like"
                location="advanced-mode"
                appTooltip="Favorite"
                tooltipKeyboardShortcut="F"
                color="hard-simple"
                shape="round"
                [iconButton]="true"
                [height]="isMobile() ? '-2' : '-1'"
                (click)="toggleAssetLike.emit()"
                [class.hidden]="asset().likes"
              >
                <app-svg src="/assets/icons/heart-empty.svg"></app-svg>
              </button>
            } @else {
              <div class="action-placeholder"></div>
            }
            <div class="spacer"></div>
            @if (gallery().enabled_feedback_options?.includes('status')) {
              <app-asset-status-button
                [gallery]="gallery()"
                [asset]="asset()"
                [location]="'advanced-mode'"
                [defaultColor]="'grey-70'"
                [advancedMode]="true"
                (onSelectStatus)="updateAssetStatus.emit($event)"
              ></app-asset-status-button>
            }
            <div class="spacer"></div>
            @if (!allowedAndEnabledFeedbackOptions().includes('color_label')) {
              <div class="action-placeholder"></div>
            } @else {
              <app-context-menu
                [options]="{ noSpacing: true, width: '240px' }"
                #menu
                contextHoverIdentifier="asset-{{ asset().id }}"
                appTooltip="Add a Color Label"
                [class.hidden]="asset().color_label"
              >
                <button
                  appButton
                  name="asset-color-label-dropdown"
                  location="advanced-mode"
                  [color]="(asset().color_label | colorLabelColor) || 'hard-simple'"
                  [iconButton]="true"
                  height="-1"
                  shape="round"
                  contextButton
                >
                  <app-svg src="/assets/icons/color-label-filled.svg"></app-svg>
                </button>
                <div contextContent>
                  <div class="button-menu">
                    <app-color-label-context
                      [currentColorLabel]="asset().color_label"
                      location="advanced-mode"
                      [colorLabels]="colorLabels()"
                      (updateColorLabel)="updateAssetColorLabel.emit($event); menu.close()"
                    ></app-color-label-context>
                  </div>
                </div>
              </app-context-menu>
            }
          </div>
        }
      </ng-container>
      <div class="name-container">
        <div class="asset-name {{ asset().status }}">
          @if (asset().status !== 'no_status') {
            <app-svg [src]="'/assets/icons/' + (asset().status | assetStatusIcon) + '.svg'"></app-svg>
          }
          <span>{{ asset().version_data.asset_name }}</span>
        </div>
      </div>
    </div>
  }
</div>
